// extracted by mini-css-extract-plugin
module.exports = {"loader-spacing":"discovery-list-container_loader-spacing__mJHcT"};